import { render, staticRenderFns } from "./WallsComponent.vue?vue&type=template&id=62a16bc4&scoped=true"
import script from "./WallsComponent.vue?vue&type=script&lang=js"
export * from "./WallsComponent.vue?vue&type=script&lang=js"
import style0 from "./WallsComponent.vue?vue&type=style&index=0&id=62a16bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a16bc4",
  null
  
)

export default component.exports